module.exports = __webpack_public_path__ + "949431a6b32134f6485289c0ed9ad59d.png";